import React, { useEffect, useState } from 'react';
import PageTitle from "../../Components/PageTitle";
import Select from 'react-select';
import axios from 'axios';
import { abstartOldUrl } from '../../Constants/constants';
// import 'bootstrap/dist/css/bootstrap.min.css';


function PaySlip(props) {
    const [loading, setLoading] = useState(false);
    const [loadingDownload, setLoadingDownload] = useState(false);
    const [download, setDownload] = useState(false);
    const [loadingRemoveFilter, setLoadingRemoveFilter] = useState(false);
    const [loadingFilter, setLoadingFilter] = useState(false);
    const [isChanged, setIsChanged] = useState(false);
    const [selectedMonth, setSelectedMonth] = useState(false);
    const [allMonthsData, setAllMonthsData] = useState([]);
    const [rows, setRows] = useState([]);

    // get payslip months of login user
    function getList() {
        axios.get(`${abstartOldUrl}pages/api/v1/payslip/list`,{
            params:{
                token: "asdf",
                emp_code: localStorage.getItem("employee_code_emp"),

            }
        })
        .then((response)=>{
            const data= response?.data;
            // console.log("pages/api/v1/payslip/list", data);
            const options= data?.data?.map((val)=>{
                return {value: val?.salary_month_year, label: val?.salary_month_year}
            });
            console.log(options);
            console.log(data?.data);
            setAllMonthsData(options);
            setRows(data?.data);
            setLoading(false);
            setLoadingRemoveFilter(false);
        })
        .catch((error)=>{
            console.error(error);
            setLoading(false);
            setLoadingRemoveFilter(false);
        })
    }
    // async function getListData(emp_code, salary_month, salary_year) {
    //     console.log("emp_code,salary_month,salary_year", emp_code, salary_month, salary_year)
    //     try {
    //         // setLoading(true);
    //         let res = await axios.get(`https://abs.abstarthr.com/pages/api/v1/payslip/download?token=654&emp_code=${emp_code}&who_is=employee&salary_month=${salary_month}&salary_year=${salary_year}`);
    //         console.log(res);


    //         // setLoading(false);

    //     } catch (error) {
    //         console.log(error);
    //         // setLoading(false);
    //     }
    // }
    // download payslip pdf function
    const payslipFilter = () => {
        try {
            const temp = rows?.filter((val) => {
                // console.log(val?.salary_month_year, selectedMonth)
                if (val?.salary_month_year === selectedMonth) {
                    return val;
                }
            });
            console.log("====>>>>temp", temp);
            setRows(temp);
            setLoadingFilter(false)
        } catch (error) {
            setLoadingFilter(false);
        }
    }
    async function removeFilter() {
        setLoadingRemoveFilter(true);
        setSelectedMonth(false);
        setIsChanged(true);
        // try {
        //     if (selectedMonth) {
        //         setLoadingRemoveFilter(true);
        //         setLoadingFilter(true);
        //         let res = await axios.get(`${abstartOldUrl}pages/api/v1/payslip/list?token=asdf&emp_code=${localStorage.getItem("employee_code_emp")}`);
        //         console.log(res);
        //         setRows(res?.data?.data);
        //         setAllMonthsData(res?.data?.data);
        //         setSelectedMonth("");
        //         setLoadingRemoveFilter(false);
        //         setLoadingFilter(false);
        //     }

        // } catch (error) {
        //     console.log(error);
        //     setLoadingRemoveFilter(false);
        //     setLoadingFilter(false);
        // }
    }
    const downloadButton = async (emp_code, salary_month, salary_year) => {
        try {
            const response = await fetch(`${abstartOldUrl}pages/api/v1/payslip/download?token=654&emp_code=${localStorage.getItem("employee_code_emp")}&who_is=employee&salary_month=${salary_month}&salary_year=${salary_year}`);
            if (!response.ok) {
                throw new Error('Network response was not ok');
            }
            const blob = await response.blob();
            const url = window.URL.createObjectURL(blob);
            const a = document.createElement('a');
            a.href = url;
            a.download = `${emp_code.replace(/ /g, "_")}_${salary_month}-${salary_year}_${new Date().toISOString().split("T")[0]}.pdf`;
            document.body.appendChild(a);
            a.click();
            document.bodyNaNpxoveChild(a);
            window.URL.revokeObjectURL(url); // Cleanup the URL object
            setLoadingDownload(false);
            setDownload(false);
        } catch (error) {
            console.error('There was a problem with the download:', error);
            setLoadingDownload(false);
            setDownload(false);
        }
    }

    useEffect(() => {
        setLoading(true);
        getList();
    }, [])
    useEffect(() => {
        if(isChanged){
            getList()
            setIsChanged(false);
        }
    }, [isChanged])

    return (
        <>
            {!loading ?
                <div class="main-content" >
                    <div class="page-content">
                        <div className="container-fluid">
                            <br />
                            <PageTitle title={`Payslip`} primary={`My Details`} />

                            <div className="card">

                                <div className="card-body">
                                    <div className="card-header">
                                        <div className="row">
                                            <div className="col-md-3 position-relative mb-5">
                                                <div>
                                                    <label>Month</label>
                                                </div>
                                                {/* <select value={selectedMonth} className=' w-100 py-2 px-2 rounded-2 border-1 border-primary-subtle' onChange={(e) => { setSelectedMonth(e.target.value); }} >
                                                    <option value="" selected disabled >Select Month</option>
                                                    {allMonthsData?.map((val) => {
                                                        return (
                                                            <option value={val?.salary_month_year}>{val?.salary_month_year}</option>
                                                        )
                                                    })}
                                                </select> */}
                                                <div className=' position-absolute z-2 w-100 pe-3'>
                                                    <Select
                                                        options={allMonthsData}
                                                        value={selectedMonth ? allMonthsData.find(option => option.value === selectedMonth) : null}
                                                        onChange={(selectedOption) => setSelectedMonth(selectedOption?.value)}
                                                        placeholder={`Select Year`}
                                                    />
                                                </div>
                                            </div>
                                            <div className="col-md-3">
                                                <div className="row">
                                                    <div className="col-md-6">
                                                        <div>
                                                            <label>Apply Filter</label>
                                                        </div>
                                                        {!loadingFilter ?
                                                            <button disabled={!selectedMonth} onClick={(e) => {
                                                                if (selectedMonth && !loadingFilter) {
                                                                    setLoadingFilter(true);
                                                                    payslipFilter();
                                                                }
                                                            }}  type="button" className="btn btn-info btn-label waves-effect waves-light w-100 ">
                                                                <i className=" ri-filter-3-fill label-icon align-middle fs-16 me-2" />Filter
                                                            </button> :
                                                            <button type="button" disabled className="btn btn-info btn-label waves-effect waves-light w-100 ">
                                                                <i className=" ri-filter-3-fill label-icon align-middle fs-16 me-2" />Loading...
                                                            </button>
                                                        }

                                                    </div>
                                                    <div className="col-md-6">
                                                        <div>
                                                            <label className=' text-nowrap'>Clear Filter</label>
                                                        </div>
                                                        {!loadingRemoveFilter ?
                                                            <button disabled={!selectedMonth} onClick={removeFilter} type="button" className="btn btn-secondary btn-label waves-effect waves-light">
                                                                <i className=" ri-database-2-line  label-icon align-middle fs-16 me-2 text-nowrap" />Clear</button> :
                                                            <button type="button" disabled className=" btn btn-secondary btn-label waves-effect waves-light">
                                                                <i className=" ri-database-2-line  label-icon align-middle fs-16 me-2 text-nowrap" />{"Loading..."} </button>
                                                        }
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>

                                    <div className="dataTables_wrapper dt-bootstrap5 no-footer">
                                        <div className="row">
                                            <div className="col-sm-12 col-md-6">
                                                {/* <div className="dataTables_length" id="example_length"><label>Show <select name="example_length" aria-controls="example" className="form-select form-select-sm">
                                                <option value={10}>10</option><option value={25}>25</option><option value={50}>50</option><option value={100}>100</option></select> entries</label>
                                            </div> */}
                                            </div>
                                        </div>
                                        <div className="row">
                                            <div style={{ "maxHeight": "65vh", "overflowY": "auto" }} className="col-sm-12">
                                                <table id="example" className="table table-bordered dt-responsive nowrap table-striped align-middle dataTable no-footer dtr-inline collapsed position-relative" style={{ width: '100%' }} >
                                                    <thead class="bg-primary text-light bg-gradient sticky-top z-1">
                                                        <tr>
                                                            <th style={{ width:"5%"}} className=' text-center'>Sr.No.</th>
                                                            <th >Employee Code</th>
                                                            <th >Salary Month Year</th>
                                                            <th style={{ width:"15%"}} className=' text-center'>Action</th>
                                                        </tr>
                                                    </thead>
                                                    <tbody>
                                                        {rows?.map((val, idx) => {
                                                            return (
                                                                <tr>
                                                                    <td className=' text-center'>{idx + 1}</td>
                                                                    <td>{val?.emp_code}</td>
                                                                    <td>{val?.salary_month_year}</td>
                                                                    <td className=' text-center'>
                                                                        {loadingDownload == val?.salary_month_year ?
                                                                            <button type="button" disabled className="btn btn-primary waves-effect wave-light bg-primary"
                                                                            >loading...
                                                                            </button>:
                                                                            <button type="button" className="btn btn-primary waves-effect wave-light bg-primary"
                                                                            onClick={(e) => { 
                                                                                setLoadingDownload(val?.salary_month_year); 
                                                                                setDownload(val?.salary_month_year); 
                                                                                downloadButton(val?.emp_code, val?.salary_month, val?.salary_year); }} >Download
                                                                            </button>}
                                                                    </td>
                                                                </tr>

                                                            )
                                                        })

                                                        }
                                                    </tbody>
                                                </table></div>
                                        </div>

                                        {/* <div className="d-flex justify-content-between w-100" >
                                            <button disabled={false} type="button" onClick={(e) => { }} className={`btn btn-warning btn-label waves-effect waves-light`}><i className="ri-arrow-left-line label-icon align-middle fs-16 me-2" /> Previous</button>
                                            <div className='col-md-4' style={{ display: 'flex', alignItems: 'center' }}>
                                                {
                                                    <small>Total Records: {100} | Total Pages: {10} | Current Page: {1}</small>
                                                }
                                            </div>
                                            <div className='col-md-2'>
                                                <select className="form-select">
                                                    <option value="1">Page 1</option>
                                                </select>
                                            </div>
                                            <div className="col-md-2">
                                                <select className="form-select" >
                                                    <option value="10">Limit 10</option>
                                                </select>
                                            </div>
                                            <button disabled={false} type="button" onClick={(e) => { }} className={`btn btn-primary btn-label waves-effect right waves-light`}><i className="ri-arrow-right-line label-icon align-middle fs-16 ms-2" /> Next</button>
                                        </div> */}
                                    </div>
                                </div>
                            </div>
                        </div >


                    </div>
                </div > :
                <div className='d-flex justify-content-center align-items-center' style={{ height: "90vh" }}>
                    <div className="text-center">
                        <div className="spinner-border text-primary" role="status">
                            <span className="visually-hidden">Loading...</span>
                        </div>
                    </div>
                </div>

            }
        </>
    );
}

export default PaySlip;